module.exports = __webpack_public_path__ + "static/logo_icon-4497aac60e01bac7c38366f431e040ad.png";